var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        ref: "table",
        staticClass: "q-mt-lg",
        attrs: {
          data: _vm.selected_items,
          columns: _vm.columns,
          selection: "multiple",
          selected: _vm.selected,
          "row-key": "content_id",
          pagination: _vm.selected_server_pagination,
          loading: _vm.loading,
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [0],
          "binary-state-sort": ""
        },
        on: {
          "update:selected": function($event) {
            _vm.selected = $event
          },
          "update:pagination": function($event) {
            _vm.selected_server_pagination = $event
          },
          request: _vm.request_selected
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("div", { staticClass: "col" }),
                _vm.selected.length > 0
                  ? _c("q-btn", {
                      staticClass: "q-mr-md",
                      attrs: {
                        color: "negative",
                        icon: "far fa-trash",
                        label: _vm.$t("remove")
                      },
                      on: {
                        click: function($event) {
                          _vm.confirm_remove = true
                        }
                      }
                    })
                  : _vm._e(),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    icon: "far fa-plus",
                    label: _vm.$t("add_news"),
                    disable: !_vm.manage_trails
                  },
                  on: {
                    click: function($event) {
                      return _vm.showAddTrainings()
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-th",
                    { attrs: { "auto-width": "" } },
                    [
                      _c("q-checkbox", {
                        attrs: {
                          "indeterminate-value": "some",
                          disable: !_vm.manage_trails
                        },
                        model: {
                          value: props.selected,
                          callback: function($$v) {
                            _vm.$set(props, "selected", $$v)
                          },
                          expression: "props.selected"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._l(props.cols, function(col) {
                    return _c(
                      "q-th",
                      { key: col.name, attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t(col.label)) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return [
                _c(
                  "q-tr",
                  { attrs: { props: props } },
                  [
                    _c(
                      "q-td",
                      { attrs: { "auto-width": "" } },
                      [
                        _c("q-checkbox", {
                          attrs: {
                            color: "primary",
                            disable: !_vm.manage_trails
                          },
                          model: {
                            value: props.selected,
                            callback: function($$v) {
                              _vm.$set(props, "selected", $$v)
                            },
                            expression: "props.selected"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      {
                        key: "content_id",
                        attrs: { props: props, "auto-width": "" }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(props.row.content_id) +
                            "\n                "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      { key: "content_title", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(props.row.content_title) +
                            "\n                "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      { key: "created_date", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(props.row.created_date) +
                            "\n                "
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      {
                        key: "status",
                        attrs: { props: props, "auto-width": "" }
                      },
                      [
                        _c(
                          "q-chip",
                          {
                            staticClass: "full-width",
                            attrs: {
                              small: "",
                              icon: _vm.getIconStatus(props.row.status),
                              color: _vm.getColorStatus(props.row.status)
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(_vm.getStatus(props.row.status))
                                ) +
                                "\n                    "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          on: {
            hide: function($event) {
              return _vm.clearSelection()
            },
            show: function($event) {
              return _vm.clearSelection()
            },
            "escape-key": function($event) {
              return _vm.clearSelection()
            }
          },
          model: {
            value: _vm.show_add_trainings,
            callback: function($$v) {
              _vm.show_add_trainings = $$v
            },
            expression: "show_add_trainings"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_add_trainings = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("news")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("q-table", {
                    attrs: {
                      data: _vm.not_selected_items,
                      columns: _vm.columns,
                      pagination: _vm.not_selected_server_pagination,
                      filter: _vm.filter_not_selected,
                      loading: _vm.loading,
                      selection: "multiple",
                      selected: _vm.selected,
                      "row-key": "content_id",
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [0],
                      "binary-state-sort": ""
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.not_selected_server_pagination = $event
                      },
                      request: _vm.request_not_selected,
                      "update:selected": function($event) {
                        _vm.selected = $event
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "top",
                        fn: function(props) {
                          return [
                            _c("q-search", {
                              staticClass: "q-mr-lg",
                              attrs: {
                                icon: "far fa-search",
                                placeholder: _vm.$t("search"),
                                "float-label": _vm.$t("search"),
                                debounce: 500
                              },
                              model: {
                                value: _vm.filter_not_selected,
                                callback: function($$v) {
                                  _vm.filter_not_selected = $$v
                                },
                                expression: "filter_not_selected"
                              }
                            }),
                            _c("div", { staticClass: "col" }),
                            _vm.selected.length > 0
                              ? _c("q-btn", {
                                  staticClass: "q-mr-md",
                                  attrs: {
                                    color: "positive",
                                    icon: "far fa-save",
                                    label: _vm.$t("add_news")
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.addSelectedTrainings()
                                    }
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-th",
                                { attrs: { "auto-width": "" } },
                                [
                                  _c("q-checkbox", {
                                    attrs: { "indeterminate-value": "some" },
                                    model: {
                                      value: props.selected,
                                      callback: function($$v) {
                                        _vm.$set(props, "selected", $$v)
                                      },
                                      expression: "props.selected"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._l(props.cols, function(col) {
                                return _c(
                                  "q-th",
                                  { key: col.name, attrs: { props: props } },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$t(col.label)) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-td",
                                { attrs: { "auto-width": "" } },
                                [
                                  _c("q-checkbox", {
                                    attrs: { color: "primary" },
                                    model: {
                                      value: props.selected,
                                      callback: function($$v) {
                                        _vm.$set(props, "selected", $$v)
                                      },
                                      expression: "props.selected"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "content_id",
                                  attrs: { props: props, "auto-width": "" }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(props.row.content_id) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "content_title",
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(props.row.content_title) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "created_date",
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(props.row.created_date) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "status",
                                  attrs: { props: props, "auto-width": "" }
                                },
                                [
                                  _c(
                                    "q-chip",
                                    {
                                      staticClass: "full-width",
                                      attrs: {
                                        small: "",
                                        icon: _vm.getIconStatus(
                                          props.row.status
                                        ),
                                        color: _vm.getColorStatus(
                                          props.row.status
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t(
                                              _vm.getStatus(props.row.status)
                                            )
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.removeTrainings },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeTrainings()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_news")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_news")))
          ])
        ]
      ),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3" },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_trails" })
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }